<template>
  <div>
    <v-layout wrap class="hidden-md-and-up">
      <v-flex xs12 sm12>
        <v-img src="../../assets/home_header_2.png" width="100%" contain>
          <template v-slot:placeholder>
            <v-row class="fill-height ma-0" align="center" justify="center">
              <v-progress-circular indeterminate color="#26af82"></v-progress-circular>
            </v-row>
          </template>
        </v-img>
      </v-flex>
    </v-layout>
    <v-layout wrap pt-md-12 px-12>
      <v-flex xs12 sm12 md6 mt-12 px-md-12>
        <p class="mainhead">A Global Investment platform for ecosystem restoration opportunities</p>
      </v-flex>
    </v-layout>
    <v-layout wrap pl-12>
      <v-flex xs3 sm3 md2 px-md-12>
        <v-divider color="#fff"></v-divider>
      </v-flex>
    </v-layout>
    <v-layout wrap pl-12>
      <v-flex xs12 sm12 md5 pt-6 px-md-12>
        <p style="font-family: montserrat_Regular;font-size: 16px;font-weight: 100;">
          "I can't imagine anything more important
          than air, water, soil, energy and biodiversity,
          These are the things that keep us alive."
          <br />
          <span style="font-family:proxima_Bold">Dr. David Suzuki</span>
        </p>
      </v-flex>
    </v-layout>
    <v-layout wrap pl-12>
      <v-flex xs12 md4 px-md-12>
        <p>
          <v-btn
            class="my-2"
            style="text-transform:none!important;color:#00a972;"
            tile
            color="white"
            small
            :ripple="false"
            router-link
            to="/AboutUs"
          >Find out more</v-btn>
        </p>
      </v-flex>
    </v-layout>
    <v-layout wrap px-12 pt-12 pb-6 text-center>
      <v-flex xs12 md12 pt-12>
        <p class="sub_head">Learn about our investment themes</p>
      </v-flex>
    </v-layout>
    <v-layout wrap pt-2 justify-center align-center>
      <v-flex xs12 md3 px-3 v-for="(item,i) in videoId" v-bind:key="i">
        <!-- <v-card flat tile> -->
        <youtube :video-id="item" ref="youtube" width="100%" height="auto" @playing="playing"></youtube>
        <!-- </v-card> -->
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
export default {
  data() {
    return {
      videoId: ["J7077absZfg", "DPgtdEw5lgI", "invUp0SX49g"]
    };
  },
  methods: {
    playing(ev) {
      var vid = ev.playerInfo.videoData.video_id;
      for (var i = 0; i < this.videoId.length; i++) {
        if (vid != this.$refs.youtube[i].videoId)
          this.$refs.youtube[i].player.pauseVideo();
      }
    }
  }
};
</script>
<style>
.sub_head {
  font-family: proxima_Bold;
  font-size: 20px;
  /* font-weight: 500; */
}
.mainhead {
  font-family: proxima_Bold;
  font-size: 30px;
  line-height: 1.2;
  font-weight: 400;
  letter-spacing: 1;
}
</style>